/* LP Combo Brinde — painel "Suas escolhas" (Item 1 + Item 2/brinde), carimbo do
   _combo_id e injecao do brinde apos o add do lencol.
   A Function so desconta composicao completa; se o add do brinde falhar, o
   cliente paga preco normal (sem brinde cobrado, sem promessa falsa).

   Refresh: o tema Horizon expoe window.CartAddEvent (assets/product-form.js:11) e
   CartAddEvent.eventName === ThemeEvents.cartUpdate (assets/events.js:114) — e o
   MESMO mecanismo que blocks/pdp-bundle.liquid usa pra re-renderizar/abrir o drawer
   depois de um add multiplo. Usamos ele; o CustomEvent generico e so fallback. */
(function () {
  var root = document.querySelector("[data-lp-combo-brinde]");
  if (!root) return;
  var COMBO_ID = root.getAttribute("data-combo-id");
  var GIFT_VARIANT_ID = parseInt(root.getAttribute("data-gift-variant-id"), 10);
  if (!COMBO_ID || !GIFT_VARIANT_ID) return;

  // 1. Carimbo no(s) form(s) de compra da pagina — cobre o caminho do product-form.js,
  //    que monta o payload com `new FormData(form)`. NAO cobre um pdp-bundle
  //    (ver carimbaPayload mais abaixo, que carimba na requisicao de saida).
  function stampForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.querySelector('input[name="properties[_combo_id]"]')) return;
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_combo_id]";
      input.value = COMBO_ID;
      form.appendChild(input);
    });
  }

  /* 1b. ANCORAR o painel "Suas escolhas" no buy box.
     A section renderiza o painel onde ela esta no template (bem abaixo do botao de
     compra). O lugar dele e imediatamente ANTES do `.buy-buttons-block`, que e onde o
     resumo do kit aparece nas PDPs/LPs com bundle — o cliente ve os dois itens antes de
     decidir. Inserimos no PAI do buy-buttons pra nao entrar dentro do form.

     Caso especial (nao ocorre nas 2 LPs de combo, onde `pdp_bundle_AkYFgR` esta
     `disabled`): se a pagina JA tem um bundle real, o painel proprio seria uma segunda
     lista "Suas escolhas". Nesse caso o painel some e so o CARD do brinde entra na lista
     do kit — o comportamento de 19/08, preservado. `blocks/pdp-bundle.liquid` nunca e
     tocado: e compartilhado com a LP carro-chefe e outras PDPs.

     O bundle re-renderiza o resumo quando o cliente usa "Alterar", o que apagaria o card
     movido — por isso a reancoragem roda no MutationObserver e e idempotente. */
  var panel = root.querySelector("[data-lp-combo-panel]");
  var giftCard = root.querySelector("[data-lp-combo-brinde-card]");
  var giftFlag = giftCard && giftCard.querySelector("[data-lp-combo-gift-flag]");

  function ancorar() {
    var bundleSummary = document.querySelector(".pdp-bundle__summary");
    if (bundleSummary) {
      if (giftFlag && giftFlag.textContent.trim() !== "Brinde") giftFlag.textContent = "Brinde";
      root.setAttribute("data-lp-combo-modo", "bundle");
      if (!giftCard) return;
      if (giftCard.parentElement === bundleSummary && bundleSummary.lastElementChild === giftCard) return;
      bundleSummary.appendChild(giftCard);
      return;
    }
    if (!panel) return;
    var buy = document.querySelector(".buy-buttons-block");
    if (!buy || !buy.parentElement) return;
    root.setAttribute("data-lp-combo-modo", "painel");
    if (panel.nextElementSibling === buy) return; // idempotente
    buy.parentElement.insertBefore(panel, buy);
  }

  /* 1c. SINCRONIZAR o Item 1 com a variante escolhida no variant-picker do buy box.
     Espelhar o DOM do buy box (parse de texto de preco) seria fragil; a fonte e o catalogo
     de variantes que a section emite em JSON, e a chave e o `input[name="id"]` do proprio
     form de compra. Escolhemos o form pela PERTINENCIA (o id tem que estar no catalogo),
     nao por posicao — a pagina tem outros forms de /cart/add (cards de cross-sell). */
  var catalogo = null;
  try {
    var elCatalogo = document.querySelector("[data-lp-combo-variants]");
    if (elCatalogo) catalogo = JSON.parse(elCatalogo.textContent);
  } catch (e) {
    console.warn("[lp-combo-brinde] catalogo de variantes invalido", e);
  }

  var mainCard = root.querySelector("[data-lp-combo-item-main]");
  var elImg = mainCard && mainCard.querySelector("[data-lp-combo-main-img]");
  var elOpts = mainCard && mainCard.querySelector("[data-lp-combo-main-opts]");
  var elPrice = mainCard && mainCard.querySelector("[data-lp-combo-main-price]");
  var elCompare = mainCard && mainCard.querySelector("[data-lp-combo-main-compare]");
  var elInst = mainCard && mainCard.querySelector("[data-lp-combo-main-inst]");
  var ultimaVariante = null;

  function brl(cents) {
    return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  function varianteSelecionada() {
    if (!catalogo || !catalogo.variants || !catalogo.variants.length) return null;
    var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      var id = parseInt(inputs[i].value, 10);
      if (!id) continue;
      for (var j = 0; j < catalogo.variants.length; j++) {
        if (catalogo.variants[j].id === id) return catalogo.variants[j];
      }
    }
    return null;
  }

  function sincronizaItem1() {
    if (!mainCard || !catalogo) return;
    var v = varianteSelecionada();
    if (!v || v.id === ultimaVariante) return; // idempotente: nao reescreve o DOM a toa
    ultimaVariante = v.id;

    if (elImg && v.img) elImg.setAttribute("src", v.img);

    if (elOpts && catalogo.options) {
      var linhas = "";
      for (var i = 0; i < catalogo.options.length; i++) {
        if (!catalogo.options[i].multi) continue;
        var valor = v.options[i];
        if (valor === undefined || valor === null) continue;
        linhas += "<div>" + catalogo.options[i].name + ": " + valor + "</div>";
      }
      if (elOpts.innerHTML !== linhas) elOpts.innerHTML = linhas;
    }

    if (elPrice) elPrice.textContent = brl(v.price);

    if (elCompare) {
      // Mesma regra do bundle (`compareBaseFor`): riscado so quando o comparativo e MAIOR.
      if (v.compare_at && v.compare_at > v.price) {
        elCompare.textContent = brl(v.compare_at);
        elCompare.removeAttribute("hidden");
      } else {
        elCompare.textContent = "";
        elCompare.setAttribute("hidden", "");
      }
    }

    if (elInst) {
      var n = catalogo.installments || 1;
      elInst.textContent = brl(Math.round(v.price / n));
    }
  }

  /* ------------------------------------------------------------------------
     "Alterar" do Item 1 -> modal ALTERAR OPCOES (24/08)

     Desenho: o `<variant-picker>` do buy box fica VISIVEL em cima do painel (igual a PDP
     de referencia) e continua sendo quem fala com o form de compra, com a midia e com a
     disponibilidade. O modal aqui so COLETA a escolha; o botao Salvar aplica clicando os
     radios do picker de verdade. Nada reimplementa o caminho do dinheiro: o
     `input[name="id"]` continua sendo escrito pelo codigo do tema. Sao dois caminhos de
     edicao que convivem — picker direto, ou Alterar -> modal.
     A referencia visual e o `#kit-customize-modal` de `blocks/pdp-bundle.liquid`.
     ------------------------------------------------------------------------ */
  function pickerDaPagina() {
    return (
      document.querySelector('variant-picker[ref="mainVariantPicker"]') ||
      document.querySelector("variant-picker") ||
      document.querySelector(".variant-picker")
    );
  }

  var modal = document.querySelector("[data-lp-combo-modal]");
  var modalOpts = modal && modal.querySelector("[data-lp-combo-modal-options]");
  var modalPreco = modal && modal.querySelector("[data-lp-combo-modal-price]");
  var modalImg = modal && modal.querySelector("[data-lp-combo-modal-img]");
  var modalSalvar = modal && modal.querySelector("[data-lp-combo-modal-save]");
  var modalMedidas = modal && modal.querySelector("[data-lp-combo-modal-sizechart]");
  var escolha = [];

  /* `position: fixed` morre dentro de ancestral com transform/filter/contain. O painel e
     movido pra dentro do buy box por `ancorar()`, entao o modal nao pode ficar junto: vive
     no body. */
  if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);

  /* O modal da tabela de medidas do tema nasce DENTRO do buy box, cujo ancestral cria um
     contexto de empilhamento proprio — la dentro o `z-index: 9999` dele so compete com os
     irmaos, e o nosso modal (filho do body) fica por cima mesmo com z-index 20. Medido:
     `elementFromPoint` no centro da tela devolvia `.lp-combo-modal__left` com a tabela ja
     aberta. Trazer o no dele pro body poe os dois no MESMO contexto, e ai 9999 > 20.
     Movemos o no ORIGINAL: o handler do tema guarda referencia a ele (getElementById no
     DOMContentLoaded), entao continua abrindo e fechando normalmente. */
  var scTema = document.getElementById("variant-picker-size-chart-modal");
  if (scTema && scTema.parentElement !== document.body) document.body.appendChild(scTema);

  function esc(txt) {
    return String(txt == null ? "" : txt).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function achaVariante(sel) {
    if (!catalogo || !catalogo.variants) return null;
    for (var i = 0; i < catalogo.variants.length; i++) {
      var v = catalogo.variants[i];
      var ok = true;
      for (var k = 0; k < sel.length; k++) {
        if (sel[k] != null && v.options[k] !== sel[k]) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  function valoresDaOpcao(idx) {
    var vistos = {};
    var out = [];
    (catalogo.variants || []).forEach(function (v) {
      var val = v.options[idx];
      if (val == null || vistos[val]) return;
      vistos[val] = 1;
      out.push(val);
    });
    return out;
  }

  function renderOpcoes() {
    if (!modalOpts || !catalogo) return;
    var html = "";
    for (var i = 0; i < catalogo.options.length; i++) {
      var valores = valoresDaOpcao(i);
      if (valores.length < 2) continue; // opcao de valor unico nao e escolha
      html +=
        '<div class="lp-combo-modal__option"><label><span>' +
        esc(catalogo.options[i].name) +
        ":</span></label>" +
        '<select data-lp-combo-opt="' +
        i +
        '">';
      for (var j = 0; j < valores.length; j++) {
        html +=
          '<option value="' +
          esc(valores[j]) +
          '"' +
          (escolha[i] === valores[j] ? " selected" : "") +
          ">" +
          esc(valores[j]) +
          "</option>";
      }
      html += "</select></div>";
    }
    modalOpts.innerHTML = html;
  }

  function atualizaPreview() {
    var v = achaVariante(escolha);
    if (modalImg && v && (v.img_lg || v.img)) modalImg.setAttribute("src", v.img_lg || v.img);
    if (modalPreco) {
      if (!v) {
        modalPreco.innerHTML = '<span class="lp-combo-modal__esgotado">Combinação indisponível</span>';
      } else {
        var n = (catalogo && catalogo.installments) || 1;
        var html = "";
        if (v.compare_at && v.compare_at > v.price) {
          html += '<span class="lp-combo-modal__price-antigo">' + brl(v.compare_at) + "</span>";
        }
        html += '<span class="lp-combo-modal__price-atual">' + brl(v.price) + "</span>";
        html +=
          '<span class="lp-combo-modal__price-inst">Ou ' + n + "x de " + brl(Math.round(v.price / n)) + " sem juros</span>";
        if (v.available === false) {
          html += '<span class="lp-combo-modal__esgotado">Esgotado</span>';
        }
        modalPreco.innerHTML = html;
      }
    }
    if (modalSalvar) modalSalvar.disabled = !v || v.available === false;
  }

  /* Trocar uma opcao pode cair numa combinacao que nao existe (ex.: cor sem aquele
     tamanho). Em vez de travar o cliente num beco, adotamos a 1a variante que casa com a
     opcao que ele acabou de mexer — o mesmo comportamento do picker do tema. */
  function escolheOpcao(idx, valor) {
    var tentativa = escolha.slice();
    tentativa[idx] = valor;
    var v = achaVariante(tentativa);
    if (!v) {
      var parcial = [];
      parcial[idx] = valor;
      v = achaVariante(parcial);
    }
    escolha = v ? v.options.slice() : tentativa;
    renderOpcoes();
    atualizaPreview();
  }

  /* Grupos de entrada do picker REAL, na ordem das opcoes. `variant_style: buttons` gera
     radios; o estilo dropdown gera selects — cobrimos os dois. */
  function gruposDoPicker() {
    var p = pickerDaPagina();
    if (!p) return [];
    var radios = p.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      var ordem = [];
      var mapa = {};
      Array.prototype.forEach.call(radios, function (el) {
        if (!mapa[el.name]) {
          mapa[el.name] = [];
          ordem.push(el.name);
        }
        mapa[el.name].push(el);
      });
      return ordem.map(function (nome) {
        return { tipo: "radio", itens: mapa[nome] };
      });
    }
    return Array.prototype.map.call(p.querySelectorAll("select"), function (s) {
      return { tipo: "select", el: s };
    });
  }

  function aplicaValor(idx, valor) {
    var g = gruposDoPicker()[idx];
    if (!g) return false;
    if (g.tipo === "radio") {
      for (var i = 0; i < g.itens.length; i++) {
        if (g.itens[i].value === valor) {
          if (g.itens[i].checked) return false;
          g.itens[i].click();
          return true;
        }
      }
      return false;
    }
    if (g.el.value === valor) return false;
    g.el.value = valor;
    g.el.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  /* Sinal de "aplicou": o `input[name="id"]` do form virou uma variante com aquele valor.
     O `checked` do radio muda no mesmo tick do click, ANTES de o tema processar — esperar
     por ele deixaria o proximo click correr contra o re-render da section. */
  function esperaOpcao(idx, valor, ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function tick() {
        var v = varianteSelecionada();
        if (v && v.options[idx] === valor) return resolve(true);
        if (Date.now() - t0 > ms) return resolve(false);
        setTimeout(tick, 100);
      })();
    });
  }

  async function salvarModal() {
    var alvo = achaVariante(escolha);
    if (!alvo) return fecharModal();
    if (modalSalvar) modalSalvar.disabled = true;
    for (var passe = 0; passe < 2; passe++) {
      for (var i = 0; i < escolha.length; i++) {
        var atual = varianteSelecionada();
        if (atual && atual.options[i] === escolha[i]) continue;
        if (!aplicaValor(i, escolha[i])) continue;
        await esperaOpcao(i, escolha[i], 3000);
      }
      var fim = varianteSelecionada();
      if (fim && fim.id === alvo.id) break;
    }
    if (modalSalvar) modalSalvar.disabled = false;
    sincronizaItem1();
    fecharModal();
  }

  function abrirModal() {
    if (!modal || !catalogo) return;
    var v = varianteSelecionada() || catalogo.variants[0];
    escolha = v ? v.options.slice() : [];
    if (modalMedidas) {
      // So oferece a tabela se o modal dela existir na pagina: quem abre e o handler
      // delegado do tema (snippets/variant-main-picker.liquid).
      if (document.getElementById("variant-picker-size-chart-modal")) modalMedidas.removeAttribute("hidden");
      else modalMedidas.setAttribute("hidden", "");
    }
    renderOpcoes();
    atualizaPreview();
    modal.classList.add("lp-combo-modal--aberto");
    document.body.style.overflow = "hidden";
  }

  function fecharModal() {
    if (!modal) return;
    modal.classList.remove("lp-combo-modal--aberto");
    document.body.style.overflow = "";
  }

  if (modal) {
    modal.addEventListener("click", function (ev) {
      if (ev.target.closest("[data-lp-combo-modal-close]")) {
        ev.preventDefault();
        fecharModal();
      }
    });
    modal.addEventListener("change", function (ev) {
      var sel = ev.target.closest("[data-lp-combo-opt]");
      if (!sel) return;
      escolheOpcao(parseInt(sel.getAttribute("data-lp-combo-opt"), 10), sel.value);
    });
    if (modalSalvar) modalSalvar.addEventListener("click", salvarModal);
    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && modal.classList.contains("lp-combo-modal--aberto")) fecharModal();
    });
  }

  function ligaAlterar() {
    /* Sem picker no DOM (bloco desabilitado no Theme Editor — ja aconteceu em 22/08 e
       24/08) o modal nao teria como aplicar a escolha. Nesse caso some o link E a dica
       "altere cada item individualmente", em vez de prometer edicao que nao existe. */
    var podeAlterar = !!pickerDaPagina() && !!modal && !!catalogo;
    var tip = panel && panel.querySelector("[data-lp-combo-tip]");
    if (tip && tip.hidden === podeAlterar) tip.hidden = !podeAlterar;
    var link = mainCard && mainCard.querySelector("[data-lp-combo-alterar]");
    if (!link) return;
    if (link.hidden === podeAlterar) link.hidden = !podeAlterar;
    if (!podeAlterar || link.dataset.lpComboLigado) return;
    link.dataset.lpComboLigado = "1";
    link.addEventListener("click", function (ev) {
      ev.preventDefault();
      abrirModal();
    });
  }

  stampForms();
  ancorar();
  sincronizaItem1();
  ligaAlterar();
  // Bundle, forms e buy box sao montados/re-renderizados tarde: refazer tudo em mutacao.
  new MutationObserver(function (muts) {
    // Mutacao que nasceu DENTRO do modal (re-render dos selects/preco) nao mexe no buy
    // box — reprocessar tudo ali seria trabalho a toa a cada troca de opcao.
    if (
      modal &&
      muts.every(function (m) {
        return modal.contains(m.target);
      })
    ) {
      return;
    }
    stampForms();
    ancorar();
    sincronizaItem1();
    ligaAlterar();
  }).observe(document.body, { childList: true, subtree: true });
  // O variant-picker pode trocar so o VALUE do input (sem mutacao de DOM) — cobrimos os
  // dois caminhos.
  document.addEventListener("variant:update", sincronizaItem1);
  document.addEventListener("change", sincronizaItem1, true);

  // 2. Apos add do lencol, adicionar o brinde (1x) e re-renderizar o carrinho.
  var addingGift = false;
  function ensureGift() {
    if (addingGift) return;
    addingGift = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasGift = cart.items.some(function (i) {
          return i.variant_id === GIFT_VARIANT_ID && i.properties && i.properties._combo_id === COMBO_ID;
        });
        var hasMain = cart.items.some(function (i) {
          return i.variant_id !== GIFT_VARIANT_ID && i.properties && i.properties._combo_id === COMBO_ID;
        });
        if (hasGift || !hasMain) return null; // idempotente; sem lencol carimbado, sem brinde
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _combo_id: COMBO_ID } }] })
        }).then(function (r) {
          if (!r.ok) throw new Error("gift add " + r.status);
          return r.json();
        }).then(refreshCart);
      })
      .catch(function (e) { console.warn("[lp-combo-brinde]", e); })
      .finally(function () { addingGift = false; });
  }

  // REFRESH nativo do tema (mesmo caminho do pdp-bundle): dispara CartAddEvent, que
  // o drawer escuta como ThemeEvents.cartUpdate. Reentrancia e barrada pela guarda
  // `addingGift` + pela checagem idempotente `hasGift` acima.
  function refreshCart(addResponse) {
    try {
      if (window.CartAddEvent) {
        document.dispatchEvent(
          new window.CartAddEvent(addResponse || {}, "lp-combo-brinde", {
            source: "product-form-component",
            itemCount: 1,
            variantId: String(GIFT_VARIANT_ID)
          })
        );
        return;
      }
    } catch (e) {
      console.warn("[lp-combo-brinde] CartAddEvent falhou, usando fallback", e);
    }
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }

  /* CARIMBO NA SAIDA (nao no form).
     Um buy box de bundle NAO serializa o form: ele monta um FormData do zero
     (`formData.append('properties[_kit_casa]','true')`), entao o input hidden do
     stampForms() acima nunca chegaria no POST. Medido na pagina servida em 18/08: o
     payload saia com _kit_casa e SEM _combo_id, e o brinde nao era concedido — a LP
     anunciava sem conceder. A correcao mora aqui, no nosso asset, e nao no
     pdp-bundle.liquid (compartilhado com a LP carro-chefe e outras PDPs). stampForms()
     fica como esta: cobre o caminho do product-form.js, que e o das 2 LPs hoje. */
  function carimbaPayload(body) {
    if (!body) return body;
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      if (!body.has("properties[_combo_id]")) body.append("properties[_combo_id]", COMBO_ID);
      return body;
    }
    if (typeof body === "string") {
      try {
        var o = JSON.parse(body);
        var itens = o.items || [o];
        for (var i = 0; i < itens.length; i++) {
          itens[i].properties = itens[i].properties || {};
          if (!itens[i].properties._combo_id) itens[i].properties._combo_id = COMBO_ID;
        }
        return JSON.stringify(o);
      } catch (e) {
        if (body.indexOf("_combo_id") === -1 && body.indexOf("id=") !== -1) {
          return body + "&properties%5B_combo_id%5D=" + encodeURIComponent(COMBO_ID);
        }
        return body;
      }
    }
    return body;
  }

  // Gancho: o tema adiciona via fetch pro /cart/add — carimbar na ida, observar na volta.
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
    /* Carimbar TODO add da pagina. Nao usar a trava `addingGift` aqui: o buy box
       dispara mais de um add e, com a trava, o 2o add saia sem carimbo e virava uma
       linha de lencol fora do combo (medido 18/08: carrinho com 2 linhas de lencol,
       uma com _combo_id e outra sem). O carimbo e idempotente e o add do proprio
       brinde ja leva o _combo_id, entao carimbar ele de novo nao faz nada. */
    if (url.indexOf("/cart/add") !== -1 && args[1] && args[1].body) {
      try { args[1].body = carimbaPayload(args[1].body); } catch (e) { console.warn("[lp-combo-brinde] carimbo", e); }
    }
    var p = origFetch.apply(this, args);
    // Ignora o proprio add do brinde, senao entra em laco de verificacao.
    if (url.indexOf("/cart/add") !== -1 && !addingGift) {
      p.then(function (res) { if (res && res.ok) setTimeout(ensureGift, 150); });
    }
    return p;
  };
  // Fallback pra add por submit de form classico.
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (form && form.action && form.action.indexOf("/cart/add") !== -1) setTimeout(ensureGift, 800);
  }, true);
})();
